
/**
 * 응답 데이터
 * @nullable
 */
export type CancelSubscription200Data = { [key: string]: unknown } | null;
